import { Flex } from "@chakra-ui/react";
import { Header } from "components/Header";
import InputComp from "components/InputComp";
import PaginationComp from "components/PaginationComp";
import TableList from "components/TableList";
import { toaster } from "components/ui/toaster";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "services/api";

const headers = ["Dealer", "Town"];

// const items = [
//   {
//     id: 1,
//     acc: "106 car shop",
//     town: "Bolton",
//   },
// ];

function Pricing() {
  const [isLoading, setIsLoading] = useState(false);
  const [list, setList] = useState([]);
  // const [selectedItem, setSelectedItem] = useState();
  const [activePage, setActivePage] = useState(1);
  const [searchtxt, setSearchTxt] = useState("");
  // const [searchLoading, setSearchLoading] = useState(false);

  const navigate = useNavigate();

  const onClickItem = (data) => {
    navigate("/pricingview", {
      state: {
        action: "pricingview-edit",
        data: data,
      },
    });
  };

  const onChangeSearchTxt = (v) => {
    setSearchTxt(v);
    getList({ searchtxt: v, page: 1 });
    // setSearchLoading(true);
  };

  const getList = async (data) => {
    setIsLoading(true);
    return api
      .getUsers({
        page: data?.page || activePage,
        searchtxt: data?.searchtxt || "",
      })
      .then((res) => {
        console.log("getList", res.data);
        setIsLoading(false);
        if (res?.status === 200) {
          if (data?.page) {
            setActivePage(data.page);
          }
          if (res?.data && res?.data[0]?.userid) {
            const l = res.data.map((item) => ({
              id: item?.userid,
              dealer: item?.companyname || "", //`${item?.firstname || ""} ${item?.lastname || ""}`,
              town: item?.town || "",
              data: item,
            }));
            setList(l);
          } else {
            setList([]);
          }
        } else {
          setList([]);
          toaster.create({
            title: res?.message,
            type: "error",
          });
        }
      });
  };

  // useEffect(() => {
  //   //  navigate("/pricingview");
  //   //  return
  //   setIsLoading(true);
  //   api.getPricing().then((res) => {
  //     setIsLoading(false);
  //     if (res?.status === 200) {
  //       console.log(res.data);
  //       const l = [];

  //       if (res?.data && res?.data[0]?.paymentid) {
  //         res.data.forEach((item) => {
  //           // l.push({
  //           //   // id: item.paymentid,
  //           //   // acc: item.paymentnumber || "",
  //           //   // town: item.paymentnumber || "",

  //           //   data: item,
  //           // });
  //         });
  //         setList(l);
  //       } else {
  //         setList([]);
  //       }
  //     } else {
  //       toaster.create({
  //         title: res?.message || "error",
  //         type: "error",
  //       });
  //     }
  //   });
  // }, []);

  const onChangePage = (data) => {
    if (data?.page === activePage) {
      return;
    }
    getList({
      page: data.page,
      // limitId: utils.getLimitId(filerLast),
      searchtxt: searchtxt
      // dealerid: utils.getDealerid(dealers),
    });
  };

  useEffect(() => {
    const cd = async () => {
      await getList();
    };
    cd();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Flex flex={1} overflow={"hidden"} direction={"column"} p={"2rem"}>
      <Header label={"Pricing & Refunds"} isLoading={isLoading} />
      <Flex justifyContent="end" mb="1rem">
        <InputComp
          type={"search"}
          onChange={onChangeSearchTxt}
          value={searchtxt}
        />
        {/* <Field.Root orientation="horizontal" w={"22rem"}>
          <Field.Label textStyle={"md"}>Search</Field.Label>
          <Input textStyle={"md"} />
        </Field.Root> */}
      </Flex>
      <TableList
        type={"simple"}
        onSelect={onClickItem}
        headers={headers}
        items={list}
      />
      <PaginationComp
        // pageSize={10}
        itemsLength={list?.length}
        activePage={activePage}
        onChange={onChangePage}
      />
    </Flex>
  );
}

export default Pricing;
